<template>
  <v-card class="pa-3 pa-md-0 item" :to="to">
    <img
      width="100%"
      class="d-block item-img"
      :src="files + img + '?resize=1&w=200'"
      :alt="title"
    />

    <div class="d-flex flex-column justify-center pr-3 px-sm-3 py-lg-2">
      <div class="text-body-1 text-sm-h6 item-title">
        {{ title }}
      </div>

      <div v-if="subtitle" class="grey--text text-body-2 mt-md-1 item-text">
        {{ subtitle }}
      </div>

      <div
        class="
          d-flex
          align-start align-sm-end
          justify-space-between
          flex-column flex-sm-row flex-wrap
          mt-auto
        "
      >
        <div>
          <template v-if="price && variants.length">
            <div class="text-caption">A partir de</div>
          </template>

          <div class="secondary--text text-h6 text-md-h5 font-weight-bold">
            {{ price ? formatPrice(price) : "Sob Consulta" }}
          </div>
        </div>

        <div>
          <v-btn
            class="text-body-2 text-none font-weight-bold pa-0"
            color="primary"
            height="auto"
            text
          >
            <v-icon class="mr-1 mb-1" size="18px"> fab fa-whatsapp </v-icon>
            Peça pelo Whatsapp
          </v-btn>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { formatPrice } from "../../utils/formatPrice";

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: "",
    },
    price: {
      type: String,
      default: "",
    },
    variants: {
      type: Array,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
  },
  computed: {
    config() {
      return this.$rest("config").item;
    },
  },
  methods: {
    formatPrice,
  },
};
</script>

<style lang="scss" scoped>
.item {
  border-radius: 4px !important;
  box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.05) !important;
  display: grid;
  grid-template-columns: 25% 75%;

  @media (max-width: 960px) {
    border-top: 1px solid #f1f1f1 !important;
    box-shadow: none !important;
    grid-template-columns: 25% auto;
  }

  @media screen and (max-width: 600px) {
    border-radius: 0 !important;
    grid-template-columns: auto 25%;
  }

  &-img {
    aspect-ratio: 1;
    border-radius: 4px 0 0 4px !important;
    -o-object-fit: cover;
    object-fit: cover;
    -o-object-position: center;
    object-position: center;

    @media screen and (max-width: 600px) {
      border-radius: 4px !important;
      order: 12;
    }
  }

  &-title {
    display: block;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &-text {
    -webkit-box-orient: vertical;
    box-orient: vertical;
    display: block;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
